module.exports = __webpack_public_path__ + "static/media/footwear.bd7b6790.svg";


//////////////////
// WEBPACK FOOTER
// ./src/stores/vlp/store/placeholders/footwear.svg
// module id = 1787
// module chunks = 10